import React from 'react';
import Comments from './Comments';
import CommentArea from './CommentArea';

const UniversalCommentModule = ({ docId, title, user, toast }) => {
    if (!docId) {
        return <div style={{ color: '#ef4444', padding: '10px' }}>Error: docId is required for UniversalCommentModule</div>;
    }

    return (
        <div className="universal-comment-module" style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            height: '100%',
            minHeight: '400px',
            backgroundColor: '#1c1c1c',
            borderRadius: '8px',
            border: '1px solid #333',
            overflow: 'hidden'
        }}>
            {title && (
                <div style={{ 
                    padding: '12px 16px', 
                    borderBottom: '1px solid #333', 
                    backgroundColor: '#262626',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <h3 style={{ margin: 0, color: '#eee', fontSize: '15px', fontWeight: '600' }}>{title}</h3>
                </div>
            )}
            <div style={{ flex: 1, overflowY: 'auto', position: 'relative' }}>
                <Comments docId={docId} user={user} toast={toast} />
            </div>
            <div style={{ flexShrink: 0, borderTop: '1px solid #333', backgroundColor: '#1c1c1c' }}>
                <CommentArea docId={docId} user={user} toast={toast} />
            </div>
        </div>
    );
};

export default UniversalCommentModule;
